import { useMemo } from 'react'
import { useScheduleDraft } from '../context/ScheduleDraftProvider'
import { ACTION } from '../context/actions'

export const useScheduleActions = () => {
  const { state, dispatch } = useScheduleDraft()
  return useMemo(
    () => ({
      schedules: state.schedules,
      activeScheduleId: state.activeScheduleId || state.schedules[0]?.id,
      errors: state.errors,
      saving: state.saving,
      selectSchedule: scheduleId => dispatch({ type: ACTION.selectSchedule, scheduleId }),
      setErrors: errors => dispatch({ type: ACTION.setErrors, errors }),
      setSaving: saving => dispatch({ type: ACTION.setSaving, saving }),
      updateSchedule: (scheduleId, patch) => dispatch({ type: ACTION.updateSchedule, scheduleId, patch }),
      addSchedule: () => dispatch({ type: ACTION.addSchedule }),
      hydrateSchedules: (schedules, activeScheduleId) =>
        dispatch({ type: ACTION.hydrate, schedules, activeScheduleId }),
      deleteSchedule: scheduleId => dispatch({ type: ACTION.deleteSchedule, scheduleId }),
      updateAnchor: (scheduleId, anchorId, patch) =>
        dispatch({ type: ACTION.updateAnchor, scheduleId, anchorId, patch }),
      addAnchor: scheduleId => dispatch({ type: ACTION.addAnchor, scheduleId }),
      removeAnchor: (scheduleId, anchorId) => dispatch({ type: ACTION.removeAnchor, scheduleId, anchorId }),
      setCombine: (scheduleId, enabled) => dispatch({ type: ACTION.setCombine, scheduleId, enabled }),
      addTargeting: scheduleId => dispatch({ type: ACTION.addTargeting, scheduleId }),
      updateTargeting: (scheduleId, rowId, patch) =>
        dispatch({ type: ACTION.updateTargeting, scheduleId, rowId, patch }),
      removeTargeting: (scheduleId, rowId) => dispatch({ type: ACTION.removeTargeting, scheduleId, rowId }),
      addEndRule: scheduleId => dispatch({ type: ACTION.addEndRule, scheduleId }),
      updateEndRule: (scheduleId, ruleId, patch) =>
        dispatch({ type: ACTION.updateEndRule, scheduleId, ruleId, patch }),
      removeEndRule: (scheduleId, ruleId) => dispatch({ type: ACTION.removeEndRule, scheduleId, ruleId }),
    }),
    [dispatch, state.activeScheduleId, state.errors, state.schedules, state.saving],
  )
}
